import React, { useEffect, useRef, useState } from 'react'

import { numberToString } from 'shared/utils'

import { calculatorValues } from './calculatorConst'
import classes from './Input.module.scss'

type Props = {
  value: number
  onChange: (value: number) => void
}

export const DistributionCalculatorInput = ({
  value,
  onChange,
}: Props): JSX.Element => {
  const [currentvalue, setValue] = useState(value)
  const [position, setPosition] = useState(`0px`)
  const max = 20000
  const min = 250

  const inputRef = useRef<HTMLInputElement>(null)
  const values = Array.from(calculatorValues.keys())

  useEffect(() => {
    function getPosition() {
      const newValue = ((currentvalue - min) * 100) / (max - min)
      // const newPosition = 8 - newValue * 0.2
      setPosition(`calc(${newValue}% + (9.5px - ${newValue} * 0.2px))`)
    }
    getPosition()
  }, [currentvalue])

  function handlerChange(value: number) {
    setValue(value)
    //Так не работает на ios :(
    // if (values.includes(value)) {
    //   onChange(value)
    // }

    const f = values.findIndex(v => v > value)
    const changeValue = f > -1 ? f - 1 : values?.length - 1

    onChange(values[changeValue])
  }

  function handlerMouseUp() {
    inputRef.current?.blur()
  }

  // function handlerInput(event: React.FormEvent<HTMLInputElement>) {
  //   const target = event.target as HTMLInputElement
  //   const currentvalue = Number(target.value)
  //   if (!values.includes(currentvalue)) {
  //     event.preventDefault()
  //     event.stopPropagation()
  //     target.value = `${value}`
  //   }
  // }

  return (
    <div className={classes.range_wrap}>
      <input
        ref={inputRef}
        type="range"
        min={min}
        max={max}
        value={currentvalue}
        onChange={e => handlerChange(Number(e.target.value))}
        onMouseUp={handlerMouseUp}
        onTouchEnd={handlerMouseUp}
        // onInput={handlerInput}
        list="settings"
      />
      <datalist id="settings">
        {values.map((value, valueIndex) => (
          <option key={valueIndex}>{value}</option>
        ))}
      </datalist>
      <div className={classes.range_value} style={{ left: position }}>
        <span>{numberToString(value)}</span>
      </div>
    </div>
  )
}
